<div class="ecb-admin-card p-4">
  <div class="d-flex justify-content-between align-items-center flex-wrap gap-3 mb-4">
    <div>
      <h1 class="ecb-section-title">My purchases</h1>
      <p class="ecb-muted mb-0">View your course bookings, payment status and invoice details.</p>
    </div>
  </div>

  <p-table [value]="orders" responsiveLayout="scroll" [paginator]="true" [rows]="10">
    <ng-template pTemplate="header">
      <tr>
        <th>Order No</th>
        <th>Date</th>
        <th>Total</th>
        <th>Status</th>
        <th style="width:220px">Actions</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-order>
      <tr>
        <td><strong>{{ order.orderNo }}</strong></td>
        <td>{{ order.createdDate | date:'mediumDate' }}</td>
        <td>{{ order.currencyCode || 'AUD' }} {{ order.totalAmount | number:'1.2-2' }}</td>
        <td><p-tag [value]="order.paymentStatus"
            [severity]="order.paymentStatus === 'Paid' ? 'success' : 'warning'"></p-tag></td>
        <td class="action_buttons">
          <button pButton type="button" class="p-button-sm p-button-outlined me-2" icon="fa fa-eye" label="View"
            (click)="viewOrderDetails(order)"></button>
          <button pButton type="button" class="p-button-sm" icon="fa fa-download" label="Invoice"
            (click)="downloadInvoice(order)"></button>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="5" class="text-center py-4">No purchases found.</td>
      </tr>
    </ng-template>
  </p-table>
</div>

<p-dialog [(visible)]="showOrderDetails" [modal]="true" [style]="{width:'760px'}" header="Order Details"
  styleClass="ecb-order-dialog">
  <div *ngIf="selectedOrder" class="order-detail-box">
    <div class="order-detail-header">
      <div>
        <span class="detail-label">Order No</span>
        <h3>{{ selectedOrder.orderNo }}</h3>
      </div>
      <p-tag [value]="selectedOrder.paymentStatus"
        [severity]="selectedOrder.paymentStatus === 'Paid' ? 'success' : 'warning'"></p-tag>
    </div>

    <div class="row g-3 mb-3">
      <div class="col-md-6">
        <div class="detail-card">
          <h4>Student Details</h4>
          <p *ngIf="selectedOrder.customerName"><strong>Name:</strong> {{ selectedOrder.customerName }}</p>
          <p *ngIf="selectedOrder.customerEmail"><strong>Email:</strong> {{ selectedOrder.customerEmail }}</p>
          <p *ngIf="selectedOrder.customerMobileNo"><strong>Phone:</strong> {{ selectedOrder.customerMobileNo }}</p>
        </div>
      </div>
      <div class="col-md-6"
        *ngIf="selectedOrder.dateRange || selectedOrder.time || selectedOrder.locationName || selectedOrder.deliveryMode">
        <div class="detail-card">
          <h4>Course Details</h4>
          <p *ngIf="selectedOrder.dateRange"><strong>Date:</strong> {{ selectedOrder.dateRange }}</p>
          <p *ngIf="selectedOrder.time"><strong>Time:</strong> {{ selectedOrder.time }}</p>
          <p *ngIf="selectedOrder.locationName"><strong>Location:</strong> {{ selectedOrder.locationName }}</p>
          <p *ngIf="selectedOrder.deliveryMode"><strong>Delivery:</strong> {{ selectedOrder.deliveryMode }}</p>
        </div>
      </div>
    </div>

    <div class="detail-card mb-3">
      <h4>Purchased Courses</h4>
      <div class="order-item-row" *ngFor="let item of getOrderItems(selectedOrder)">
        <div>
          <strong>{{ item.courseName }}</strong>
          <span *ngIf="item.dateRange || item.locationName">{{ item.dateRange }} {{ item.locationName ? ' • ' +
            item.locationName : '' }}</span>
        </div>
        <b>{{ selectedOrder.currencyCode || 'AUD' }} {{ item.lineAmount | number:'1.2-2' }}</b>
      </div>
    </div>

    <div class="total-panel">
      <span>Total Paid</span>
      <strong>{{ selectedOrder.currencyCode || 'AUD' }} {{ selectedOrder.totalAmount | number:'1.2-2' }}</strong>
    </div>

    <div class="text-end mt-3">
      <button class="ecb-btn-primary" type="button" (click)="downloadInvoice(selectedOrder)"><i
          class="fa fa-download"></i> Download Invoice</button>
    </div>
  </div>
</p-dialog>